import React from 'react'
import Input from 'antd/lib/input'
import Button from 'antd/lib/button'
import Dropdown from 'antd/lib/dropdown'
import { SketchPicker } from 'react-color'
import 'antd/dist/antd.css'
import './index.less'

/**
 * Component which pick color.
 * @param color Color HEX code.
 * @param onChange Handler to change color.
 * @param placeholder Placeholder in input.
 * @returns {JSX.Element}
 * @constructor
 */
export default class InputColor extends React.Component {
  constructor(props) {
    super(props)
    this.handleColorPick = this.handleColorPick.bind(this)
  }

  /**
   * Handler to emit event in input field.
   * @param newColor Color value.
   */
  handleColorPick(newColor) {
    this.triggerChange(newColor.hex)
  }

  triggerChange(changedValue) {
    const { onChange } = this.props
    if (onChange) {
      onChange(changedValue)
    }
  }

  render() {
    const { value } = this.props
    return (
      <Input
        value={value}
        suffix={
          <Dropdown
            trigger={['click']}
            overlay={
              <div>
                <SketchPicker
                  color={value}
                  onChangeComplete={this.handleColorPick}
                />
              </div>}
          >
            <Button size='small' style={{ background: value }}> </Button>
          </Dropdown>
          }
      />
    )
  }
}



// WEBPACK FOOTER //
// src/components/InputColor/index.jsx